<template>
  <div class="col-md-12 col-lg-11 offset-lg-1 mb-3">
    <div class="filter row mr-4">
      <div
        class="col-lg-2 col-md-2 col-sm-12 filter__title d-flex align-items-center p-0"
      >
        <button
          class="btn btn-icon shadow-none p-0"
          @click="copyUrl()"
          data-toggle="tooltip"
          data-placement="top"
          title="Copier l'URL du filtre"
        >
          <svg-icon icon-class="copy" className="" />
        </button>
        Filtrer par :
      </div>
      <div class="col-md-3 col-sm-10 filter__item">
        <div class="search-container">
          <input
            v-model="q"
            type="text"
            class="form-control form-control-serach form-control-light"
            placeholder="Mot clé"
            @keypress.enter="triggerFilter"
          />
          <svg-icon
            icon-class="search-icon"
            className="search-icon"
            @click="triggerFilter"
          />
        </div>
      </div>

      <div class="col-md-1 col-sm-1 filter__item" v-if="lgBreakpoint">
        <div class="filter__item-sep"></div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-10 filter__item" v-if="lgBreakpoint">
        <div>
          <select
            v-model="filter.parcours"
            class="form-select form-control-light"
          >
            <option value="" selected>Parcours</option>
            <option
              v-for="(option, index) in parcours"
              :value="option.id || option.slug"
              :key="index"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 col-sm-10 filter__item d-none">
        <atom-select
          v-model="filter.thematique"
          :options="thematiqueOptions"
          placeholder="Univers"
          label="Thématique"
          type="text"
          select-class="form-select form-control-light"
          label-class="d-none"
          default=""
        />
      </div>
      <div class="col-md-2 col-sm-10 filter__item" v-if="lgBreakpoint">
        <select v-model="filter.city" class="form-select form-control-light">
          <option value="" selected>Ville</option>
          <option
            v-for="(option, index) in cityOptions"
            :value="option.id || option.slug"
            :key="index"
          >
            {{ option.name }}
          </option>
        </select>
      </div>

      <div class="col-md-2 col-sm-10 filter__item d-none">
        <atom-select
          v-model="filter.modalite"
          :options="modaliteOptions"
          placeholder="Modalité"
          label="Modalité"
          type="text"
          select-class="form-select form-control-light"
          label-class="d-none"
          default=""
        />
      </div>
      <div class="col-md-2 col-sm-10 filter__item d-lg-flex" v-if="lgBreakpoint">
        <atom-select
          v-model="filter.format"
          :options="formatOptions"
          placeholder="Format"
          label="Format"
          type="text"
          select-class="form-select form-control-light"
          label-class="d-none"
          default=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  useBreakpoints,
  breakpointsBootstrapV5,
  useUrlSearchParams,
} from '@vueuse/core'
import { mapFields } from 'vuex-map-fields'
const parse = require('url-parse')
import { lazyInput } from 'vue-lazy-input'
import AtomSelect from '@/components/atoms/AtomSelect'
import Swal from 'sweetalert2'
export default {
  name: 'FilterTrainings',
  components: { AtomSelect },
  directives: {
    lazyInput,
  },
  setup() {
    const breakpoints = useBreakpoints(breakpointsBootstrapV5)
    const lgBreakpoint = breakpoints.greater('sm')
    const urlsearchParams = useUrlSearchParams('history')

    return { lgBreakpoint, urlsearchParams }
  },
  data() {
    return {
      isLoaded: false,
      q: '',
      encodedNoFilters: null,
      filter: {
        q: '',
        thematique: '',
        region: '',
        city: '',
        modalite: '',
        format: '',
        parcours: '',
      },
      Toast: Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: false,
      }),
    }
  },
  computed: {
    encodedFilters() {
      if (
        this.filter.q == '' &&
        this.filter.thematique == '' &&
        this.filter.region == '' &&
        this.filter.city == '' &&
        this.filter.modalite == '' &&
        this.filter.format == '' &&
        this.filter.parcours == ''
      ) {
        return this.encodedNoFilters
      } else
        return !this.$lodash.isEmpty(this.filter)
          ? btoa(JSON.stringify(this.filter))
          : null
    },

    ...mapFields('app', [
      'thematiqueOptions',
      'regionOptions',
      'cityOptions',
      'formatOptions',
      'modaliteOptions',
      'parcours',
    ]),
  },
  watch: {
    encodedFilters(val) {
      if (val && this.encodedNoFilters != val) {
        this.$bus.$emit('handle.filter', this.filter)
      } else {
        this.$bus.$emit('handle.filter.reset')
      }
    },
  },

  mounted() {
    this.$bus.$on('handle.filter', () => {
      if (!this.lgBreakpoint) {
        let accordions = document
          .getElementById('app')
          .getElementsByClassName('accordion-collapse')
        let accordionBtns = document
          .getElementById('app')
          .getElementsByClassName('accordion-button')
        for (var i = 0; i < accordionBtns.length; i++) {
          accordionBtns[i].classList.remove('collapsed')
          accordions[i].classList.add('show')
        }
        accordionBtns[0].scrollIntoView({
          behavior: 'smooth',
        })
      }
    })
    this.$nextTick(() => {
      const f = {
        q: '',
        thematique: '',
        region: '',
        city: '',
        modalite: '',
        format: '',
        parcours: '',
      }
      this.encodedNoFilters = btoa(JSON.stringify(f))
    })
    let url = parse(window.location.href, true)
    let f = {
      thematique: '',
      region: '',
      city: '',
      modalite: '',
      format: '',
      parcours: '',
      q: '',
    }
    let search =
      url.query.search && url.query.search != '' ? url.query.search : ''
    const thematique =
      url.query.thematique && url.query.thematique != ''
        ? url.query.thematique
        : ''
    const region =
      url.query.region && url.query.region != '' ? url.query.region : ''
    const city = url.query.city && url.query.city != '' ? url.query.city : ''
    const modalite =
      url.query.modalite && url.query.modalite != '' ? url.query.modalite : ''
    const format =
      url.query.format && url.query.format != '' ? url.query.format : ''
    const parcours =
      url.query.parcours && url.query.parcours != '' ? url.query.parcours : ''

    if (search && search != '') {
      f.q = search
      this.q = search
    }
    if (thematique && thematique != '') f.thematique = thematique
    if (region && region != '') f.region = region
    if (city && city != '') f.city = city
    if (modalite && modalite != '') f.modalite = modalite
    if (format && format != '') f.format = format
    if (parcours && parcours != '') f.parcours = parcours

    if (
      f.q ||
      f.thematique ||
      f.region ||
      f.city ||
      f.modalite ||
      f.format ||
      f.parcours
    ) {
      setTimeout(() => {
        this.filter = this.$lodash.cloneDeep(f)
      }, 250)
    }
  },
  methods: {
    copyUrl() {
      const q = this.filter?.q ?? ''
      const parcours = this.filter?.parcours ?? ''
      const city = this.filter?.city ?? ''
      const format = this.filter?.format ?? ''
      this.urlParams = `${window.location.origin}/formations/?search=${q}&parcours=${parcours}&city=${city}&format=${format}`
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard

      clipboardData.writeText(this.urlParams)
      this.Toast.fire({
        icon: 'success',
        title: "l'URL est copiée dans votre presse-papier !",
      })
    },
    triggerFilter() {
      this.filter.q = this.q
    },
    tokenize(text) {
      return text.split(/[\s,.!?;:([\]'"¡¿)/]+/).filter((x) => x)
    },
  },
}
</script>

<style>
@media screen and (min-width: 991px) and (max-width: 1200px) {
  .filter > div {
    font-size: 13px;
  }
}
</style>
